/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { WebApiModelsInvite } from './WebApiModelsInvite';
import {
    WebApiModelsInviteFromJSON,
    WebApiModelsInviteFromJSONTyped,
    WebApiModelsInviteToJSON,
} from './WebApiModelsInvite';

/**
 * 
 * @export
 * @interface WebApiServicesDataTransferObjectsInviteServiceGetInvitesResultDto
 */
export interface WebApiServicesDataTransferObjectsInviteServiceGetInvitesResultDto {
    /**
     * 
     * @type {Array<WebApiModelsInvite>}
     * @memberof WebApiServicesDataTransferObjectsInviteServiceGetInvitesResultDto
     */
    invites?: Array<WebApiModelsInvite> | null;
}

/**
 * Check if a given object implements the WebApiServicesDataTransferObjectsInviteServiceGetInvitesResultDto interface.
 */
export function instanceOfWebApiServicesDataTransferObjectsInviteServiceGetInvitesResultDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function WebApiServicesDataTransferObjectsInviteServiceGetInvitesResultDtoFromJSON(json: any): WebApiServicesDataTransferObjectsInviteServiceGetInvitesResultDto {
    return WebApiServicesDataTransferObjectsInviteServiceGetInvitesResultDtoFromJSONTyped(json, false);
}

export function WebApiServicesDataTransferObjectsInviteServiceGetInvitesResultDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebApiServicesDataTransferObjectsInviteServiceGetInvitesResultDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'invites': !exists(json, 'invites') ? undefined : (json['invites'] === null ? null : (json['invites'] as Array<any>).map(WebApiModelsInviteFromJSON)),
    };
}

export function WebApiServicesDataTransferObjectsInviteServiceGetInvitesResultDtoToJSON(value?: WebApiServicesDataTransferObjectsInviteServiceGetInvitesResultDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'invites': value.invites === undefined ? undefined : (value.invites === null ? null : (value.invites as Array<any>).map(WebApiModelsInviteToJSON)),
    };
}

